module.exports = __webpack_public_path__ + "img/anf2.9ae746a4.png";